import API from '../../../../../services/api';

export const MARCAS_API = {
    get: async () => {
        return await API.get('/marcas').then(res => res.data);
    },
    new: async (marca) => {
        return API.post('/marcas', marca).then(res => res.data);
    },
    update: async (marca) => {
        return API.put('/marcas/' + marca.id, marca).then(res => res.data);
    }
}